import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setIsClosed as setBoardIsClosed
} from 'store/redux/boards'

export default function * requestOpenBoard (action) {
  const { id, onSuccess, onFail } = action.payload

  const optimisticAction = yield optimisticPut(setBoardIsClosed({
    id,
    isClosed: false
  }))

  try {
    yield call(apiAction, 'OpenBoard', {
      boardId: id
    })

    onSuccess && onSuccess()

    yield optimisticAction.commit()
  } catch (error) {
    onFail && onFail(error)

    yield optimisticAction.revert()

    throw error
  }
}
